import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { InvoiceDeliveryMethodIntegerEnum } from 'src/shared/models/enums/invoiceDeliveryMethodInteger.enum';
import { InvoiceMailSenderModal } from './invoiceMailSenderModal';

type SendInvoiceMenuProps = {
  invoiceId: number;
  refetchData: () => void;
};

const SendInvoiceMenu = (props: SendInvoiceMenuProps) => {
  const { invoiceId, refetchData } = props;
  const { t } = useTranslation(['invoice', 'common']);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const [open, setOpen] = useState(false);
  const [showInvoiceMailSender, setShowInvoiceMailSender] = useState<boolean>(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleSending = (event: Event | React.SyntheticEvent, deliveryMethod?: InvoiceDeliveryMethodIntegerEnum) => {
    switch (deliveryMethod) {
      case InvoiceDeliveryMethodIntegerEnum.mail:
        setShowInvoiceMailSender(true);
        break;
      case InvoiceDeliveryMethodIntegerEnum.letter:
        break;
      case InvoiceDeliveryMethodIntegerEnum.sms:
        break;
      default:
        setOpen(false);
    }
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Stack direction='row' spacing={2} sx={{ ml: 2 }}>
        <Box>
          <Button
            ref={anchorRef}
            id='composition-button'
            aria-controls={open ? 'composition-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup='true'
            onClick={handleToggle}
            variant='contained'
            endIcon={<ArrowDropDown />}
          >
            {t('common:button.send')}
          </Button>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement='bottom-start'
            transition
            disablePortal
            nonce={undefined}
            sx={{ zIndex: 999 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleSending}>
                    <MenuList id='composition-menu' aria-labelledby='composition-button'>
                      <MenuItem onClick={(event) => handleSending(event, InvoiceDeliveryMethodIntegerEnum.mail)}>
                        {t('invoice:send.viaEmail')}
                      </MenuItem>
                      {/* <MenuItem onClick={(event) => handleSending(event, InvoiceDeliveryMethodEnum.letter)}>{t('invoice:send.viaLetter')}</MenuItem>
                      <MenuItem onClick={(event) => handleSending(event, InvoiceDeliveryMethodEnum.sms)}>{t('invoice:send.viaSMS')}</MenuItem> */}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Stack>
      {showInvoiceMailSender && invoiceId && (
        <InvoiceMailSenderModal
          onClose={() => setShowInvoiceMailSender(false)}
          onSave={() => {
            refetchData();
            setShowInvoiceMailSender(false);
          }}
          modalOpen={showInvoiceMailSender}
          invoiceIds={[invoiceId]}
        />
      )}
    </>
  );
};

export default SendInvoiceMenu;
